import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { formInputTheme } from "./formInputTheme";
export var StyledInput = styled("input")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: inherit;\n    font-size: ", ";\n    line-height: ", "px;\n    font-weight: ", ";\n\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0px ", " 0px ", ";\n    width: 100%;\n    outline: none;\n\n    color: ", ";\n    background-color: transparent;\n    &[aria-disabled=\"true\"] {\n        color: ", ";\n        cursor: not-allowed;\n    }\n    &::placeholder {\n        color: ", ";\n    }\n    ", "\n\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n\n    border-style: none;\n    // Use the outer component's radius.\n    border-radius: inherit;\n"])), function (_ref) {
  var themeMode = _ref.themeMode,
    variant = _ref.variant;
  return formInputTheme.fontSize[variant](themeMode);
}, function (_ref2) {
  var themeMode = _ref2.themeMode;
  return formInputTheme.lineHeight(themeMode);
}, function (_ref3) {
  var themeMode = _ref3.themeMode;
  return formInputTheme.fontWeight(themeMode);
}, getPaddingRight, getPaddingLeft, function (_ref4) {
  var themeMode = _ref4.themeMode;
  return formInputTheme.textColor.rest(themeMode);
}, function (_ref5) {
  var themeMode = _ref5.themeMode;
  return formInputTheme.textColor.readonly(themeMode);
}, function (_ref6) {
  var themeMode = _ref6.themeMode;
  return formInputTheme.placeholderColor.rest(themeMode);
}, function (_ref7) {
  var isHovered = _ref7.isHovered,
    themeMode = _ref7.themeMode;
  return isHovered ? "&::placeholder {\n                color: ".concat(formInputTheme.placeholderColor.hover(themeMode), ";\n            }") : "";
});

// The following functions are necessary because the padding of the input is dependent on the
// presence of content before/after. In Ursa, with content before/after the padding is 8px. Without, it's 12px (really 11px due to the border).
function getPaddingLeft(_ref8) {
  var themeMode = _ref8.themeMode,
    hasContentBefore = _ref8.hasContentBefore,
    validationState = _ref8.validationState;
  if (!hasContentBefore) {
    return validationState === "error" ? formInputTheme.padding.default.error(themeMode) : formInputTheme.padding.default.rest(themeMode);
  } else {
    return formInputTheme.padding.betweenContent(themeMode);
  }
}
function getPaddingRight(_ref9) {
  var themeMode = _ref9.themeMode,
    hasContentAfter = _ref9.hasContentAfter,
    validationState = _ref9.validationState;
  if (!hasContentAfter) {
    return validationState === "error" ? formInputTheme.padding.default.error(themeMode) : formInputTheme.padding.default.rest(themeMode);
  } else {
    return formInputTheme.padding.betweenContent(themeMode);
  }
}
//# sourceMappingURL=StyledInput.js.map